import { combineReducers } from "@reduxjs/toolkit";

import { coachmarksReducer } from "entities/coachmarks/reducer";
import { eventsReducer } from "entities/events/reducer";
import { initiativesReducer } from "entities/initiatives/reducer";
import { knowledgeReducer } from "entities/knowledge/reducers";
import { languagesReducer } from "entities/languages/reducer";
import { permissionsReducer } from "entities/permissions/reducer";
import { stakeholdersReducer } from "entities/stakeholders/reducer";
import { topicsReducer } from "entities/topics/reducer";

export const entitiesReducer = combineReducers({
  coachmarks: coachmarksReducer,
  events: eventsReducer,
  initiatives: initiativesReducer,
  knowledge: knowledgeReducer,
  languages: languagesReducer,
  permissions: permissionsReducer,
  stakeholders: stakeholdersReducer,
  topics: topicsReducer,
});
